import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ActivityState } from '../state/activity.state'

const getActivityState = createFeatureSelector<ActivityState>('activity')

export const getActivityDashboardInfo = createSelector(getActivityState, (state) => state?.dashboard)

export const getActivityDetails = () =>
  createSelector(getActivityState, (state) => {
    return state?.details
  })

export const activitySummaryDetailsSelector = () =>
  createSelector(getActivityState, (state) => {
    return state?.summary
  })
